import { Checkbox, Flex } from "@mantine/core";
import {
  IconLetterE,
  IconLetterN,
  IconLetterS,
  IconLetterW,
} from "@tabler/icons-react";
import { type ChangeEventHandler, useCallback } from "react";

import { useInputProps } from "../hooks/useInputProps";
import Coordinates from "./Coordinates";

interface ICoordinates {
  isLatitude: boolean;
  isLongitude: boolean;
  value: string | { nums: string; dir: string };
  id: string;
  twoDigit?: boolean;
  exclusive?: string;
  required?: boolean;
}

const OilCoordinates = (props: ICoordinates) => {
  const baseName =
    props.exclusive && props.exclusive.trim() !== ""
      ? `${props.id}-exclusive-${props.exclusive}`
      : props.id;
  const coordId = baseName + ".nums";
  const dirId = baseName + ".dir";
  const defDir = typeof props.value === "string" ? "" : props.value?.dir;
  const dirProps = useInputProps(dirId, defDir, props.required, true);

  const getDefVal = useCallback(() => {
    let value = "";
    if (props.value) {
      if (typeof props.value === "string") value = props.value;
      else if (typeof props.value === "object") value = props.value?.nums;
    }

    if (!(!isNaN(parseFloat(value)) && isFinite(parseFloat(value)))) value = "";

    return value;
  }, [props.value]);

  const handleCheck: ChangeEventHandler<HTMLInputElement> = e => {
    dirProps.onChange(e.target.checked ? e.target.value : "");
  };

  return (
    <Flex align="center" gap="sm">
      <Coordinates
        {...props}
        id={coordId}
        value={getDefVal()}
        required={props.required}
        isLat3={props?.twoDigit === true}
      />
      <Checkbox
        checked={dirProps.value === (props.isLatitude ? "N" : "E")}
        value={props.isLatitude ? "N" : "E"}
        error={!["N", "E", "S", "W"].includes(dirProps.value) && dirProps.error}
        onChange={handleCheck}
        icon={icon =>
          props.isLatitude ? (
            <IconLetterN {...icon} size={16} />
          ) : (
            <IconLetterE {...icon} size={16} />
          )
        }
        indeterminate
        size="xl"
        styles={{ labelWrapper: { display: "none" } }}
      />
      <Checkbox
        checked={dirProps.value === (props.isLatitude ? "S" : "W")}
        value={props.isLatitude ? "S" : "W"}
        error={!["N", "E", "S", "W"].includes(dirProps.value) && dirProps.error}
        onChange={handleCheck}
        icon={icon =>
          props.isLatitude ? (
            <IconLetterS {...icon} size={16} />
          ) : (
            <IconLetterW {...icon} size={16} />
          )
        }
        indeterminate
        size="xl"
        styles={{ labelWrapper: { display: "none" } }}
      />
    </Flex>
  );
};

export default OilCoordinates;
